import { TFunction } from 'i18next';

import { BenchmarkResultsInputRequest } from '../../../../../../generated/model/benchmarkResultsInputRequest';

interface Option<T> {
  value: T;
  label: string;
}

export const tpPliList: Option<BenchmarkResultsInputRequest.ProfitLevelIndicatorEnum>[] = [
  {
    value: 'EBIT_MARGIN_TURNOVER',
    label: 'benchmark:benchmarkResults.input.ebitMarginTurnover',
  },
  {
    value: 'NET_COST_PLUS_TURNOVER',
    label: 'benchmark:benchmarkResults.input.netCostPlusTurnover',
  },
  {
    value: 'GROSS_PROFIT_MARK_UP',
    label: 'benchmark:benchmarkResults.input.grossProfitMarkUp',
  },
  {
    value: 'GROSS_PROFIT_MARGIN',
    label: 'benchmark:benchmarkResults.input.grossProfitMargin',
  },
  {
    value: 'BERRY_RATIO',
    label: 'benchmark:benchmarkResults.input.berryRation',
  },
  {
    value: 'RETURN_ON_ASSETS',
    label: 'benchmark:benchmarkResults.input.returnOnAssets',
  },
  {
    value: 'RETURN_ON_CAPITAL_EMPLOYED',
    label: 'benchmark:benchmarkResults.input.returnOnCapitalEmployed',
  },
];

export const findLabelByValue = (
  t: TFunction,
  value?: BenchmarkResultsInputRequest.ProfitLevelIndicatorEnum,
) => {
  const tpPliItem = tpPliList.find((item) => item.value === value);
  return tpPliItem ? t(tpPliItem.label) : '';
};
